import {Injectable} from '@angular/core';
import {FrontendDocument} from '@nachdigal';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UpdateDocumentService {
  public documentSource = new BehaviorSubject<FrontendDocument>(null);
  public currentDocument = this.documentSource.asObservable();

  changeDocument(document: FrontendDocument): void {
    this.documentSource.next(document);
  }
}
